var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSmileys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1C2.34 1 1 2.34 1 4v6c0 1.66 1.34 3 3 3h4.5c0-2.48 2.02-4.5 4.5-4.5V4c0-1.66-1.34-3-3-3H4zm2.38 3.25c.34.23.43.7.2 1.04-.23.34-.7.43-1.04.2a.781.781 0 0 0-.91.01c-.13.09-.28.13-.43.13-.23 0-.47-.11-.61-.31a.753.753 0 0 1 .18-1.05c.77-.55 1.82-.56 2.61-.02zm1.84 4.11c-.35-.28-.77-.43-1.22-.43-1 0-1.83.76-1.94 1.74h2.1c.41 0 .75.34.75.75s-.34.75-.75.75H4.84c-.71 0-1.29-.58-1.29-1.29 0-1.9 1.55-3.45 3.45-3.45.78 0 1.55.27 2.16.76.32.26.37.73.11 1.05-.26.33-.73.38-1.05.12zm1.32-2.87a.781.781 0 0 0-.91.01c-.13.09-.28.13-.43.13-.23 0-.47-.11-.61-.31a.753.753 0 0 1 .18-1.05c.77-.55 1.82-.56 2.61-.02.34.23.43.7.2 1.04-.23.34-.7.43-1.04.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.94 16.559h-3.88c-.11 0-.21.04-.28.12-.07.08-.11.19-.09.29a2.328 2.328 0 0 0 2.31 2.08c1.19 0 2.18-.89 2.31-2.08a.363.363 0 0 0-.37-.41z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3h6c1.65 0 3-1.35 3-3v-6c0-1.65-1.35-3-3-3h-6zm.64 2.99a.8.8 0 0 0 .9.01c.34-.24.81-.15 1.04.2.23.34.15.81-.2 1.04-.39.26-.84.4-1.29.4-.47 0-.93-.14-1.32-.42a.753.753 0 1 1 .87-1.23zm-1.09 3.73c0-.71.58-1.29 1.29-1.29h4.32c.71 0 1.29.58 1.29 1.29 0 1.9-1.55 3.45-3.45 3.45-1.9 0-3.45-1.55-3.45-3.45zm5.54-2.09c-.47 0-.93-.14-1.32-.42a.753.753 0 1 1 .87-1.23.8.8 0 0 0 .9.01c.34-.24.81-.15 1.04.2.23.35.14.81-.2 1.04-.39.26-.84.4-1.29.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSmileys);
export default __webpack_public_path__ + "static/media/vuesax-bold-smileys.e07863f30dedf661d07742ee54d215c8.svg";
export { ForwardRef as ReactComponent };